export default criteria =>
  criteria.map(c => {
    if (c.field && ['picklist'].includes(c.field.type))
      return c.toApiWithContriesArray()
    return c.toApi()
  })



// WEBPACK FOOTER //
// ./src/components/page/ObjectFilter/components/ViewActions/flow/utils.js